// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (users-edit e users-list)

import { Injectable } from '@angular/core';
import { Users } from './users.model';
import { Subject } from 'rxjs';

@Injectable()
export class UsersService {
  private users: Users[] = [];
  usersChanged = new Subject<Users[]>();
  usersEditMode = new Subject<number>();

  constructor(
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editUsers(usersId: number) {
    this.usersEditMode.next(usersId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setUsers(users: Users[]) {
    if (users !== null) {
      this.users = users;
      this.usersChanged.next(this.users.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getUsersByIndex(id: number) {
    return this.users.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getUsers() {
    return this.users;
  }
  
  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addUsers(users: Users) {
    users.id = this.users.length;
    this.users.push(users);
    this.usersChanged.next(this.users.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateUsers(index: number, users: Users) {
    this.users[index] = users;
    this.usersChanged.next(this.users.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteUsers(id) {
    var elementPos = this.users.map(function (x) { return x.id; }).indexOf(id);
    this.users.splice(elementPos, 1);
    this.usersChanged.next(this.users.slice());
  }
}
